import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { Box } from 'components/elements'
import { Row, ContentWrapper, Heading, InlineTextCss, logo, Root, RowStyle, TableStyle, StyledCell, Footer } from './style'
import { Button } from 'components/button'
import { useEffect, useRef, useState } from 'react'
import { useGetPolicies } from 'features/insurance/api/getPolicies'
import useAuth from 'hooks/use-auth'
import constants from './constant.json'
import { InsurancePolicyEnum } from 'features/incidents/components/enums'
import { convertDocUrlsToBase64 } from 'utils/function'
import { StyledRow, StyledTable } from 'features/incidents/components/style'
import { CircularProgress } from '@mui/material'
import { TERMINOLOGY } from 'utils/enum'

export const PDF = () => {
  const { user } = useAuth()
  const [signatureFiles, setSignatureFiles] = useState<string[]>([])
  const [downloadStatus, setDownloadStatus] = useState<boolean>(true)

  const currentUserName = user?.firstName ? `${user.firstName} ${user.lastName ? user.lastName : ''}` : ''
  const userAddress = user?.email
  const { data } = useGetPolicies()
  const insurancePolicies = data?.data
  const sig = insurancePolicies?.stampUrl?.urls

  useEffect(() => {
    const sigFile = async () => {
      const insuraceUrl = await convertDocUrlsToBase64(sig)
      setSignatureFiles(insuraceUrl)
    }
    sigFile()
  }, [sig])

  const hiddenDivRef = useRef<HTMLDivElement>(null)

  const downloadPdfDocuments = () => {
    if (hiddenDivRef.current) {
      setDownloadStatus(false)
      const hiddenDivHtml = hiddenDivRef.current

      html2canvas(hiddenDivHtml).then(canvas => {
        const imgData = canvas.toDataURL('image/png')
        const imgWidth = 210
        const imgHeight = (canvas.height * imgWidth) / canvas.width
        const doc = new jsPDF('p', 'mm')
        doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight)
        doc.save(`COW_${currentUserName}`)
        setDownloadStatus(true)
      })
    }
  }

  return (
    <>
      <Button
        onClick={downloadPdfDocuments}
        style={{
          display:
            insurancePolicies?.planStatus === InsurancePolicyEnum.CANCELLED ||
            insurancePolicies?.planStatus === InsurancePolicyEnum.PAYMENT_OVER_DUE ||
            insurancePolicies?.planStatus === InsurancePolicyEnum.EXPIRED
              ? 'none'
              : 'flex',
        }}
        disabled={!downloadStatus}
      >
        {downloadStatus === false ? <CircularProgress size={18} sx={{ color: 'var(--colors-white) !important' }} /> : ' Certificate Of Warranty'}
      </Button>
      <Root
        css={{
          fontWeight: '$semibold',
          position: 'absolute',
          top: '-9999px',
          left: '-9999px',
        }}
        ref={hiddenDivRef}
      >
        {/* logo,heading and content */}
        <TopContent />
        {/* Table */}
        <StyledTable css={TableStyle}>
          {/* 1srow */}
          <StyledRow css={RowStyle} className="td">
            {/* 1st column */}
            <StyledCell css={{ borderRight: '1px solid $gray12', px: '$4' }}>
              <Box as="h4">DLTAlert, Inc. Information</Box>
              {/* <Row> */}
              <Box as="h4" style={{ marginBottom: 8 }}>
                Contact Us:
              </Box>
              <Box as="h4" style={{ fontWeight: 'normal' }}>
                info@dltalert.com
              </Box>
            </StyledCell>
            {/* 2ndcolumn */}
            <StyledCell css={{ px: '$4' }}>
              <Box as="h4">Warranty Holder </Box>
              <Row>
                <Box as="h4" style={{ marginBottom: 8 }}>
                  Name:
                </Box>
                <Box as="h4" style={{ fontWeight: 'normal' }}>
                  {currentUserName}
                </Box>
              </Row>

              <Row>
                <Box as="h4" css={InlineTextCss} style={{ marginBottom: 8 }}>
                  Email:
                </Box>
                <Box as="h4" style={{ fontWeight: 'normal' }}>
                  {user?.email}
                </Box>
              </Row>
              <Row>
                <Box as="h4" css={InlineTextCss} style={{ marginBottom: 8 }}>
                  Phone Number:
                </Box>
                <Box as="h4" style={{ fontWeight: 'normal' }}>
                  {user?.phoneNum}
                </Box>
              </Row>
            </StyledCell>
          </StyledRow>
          {/* 2nd row */}
          <StyledRow css={RowStyle}>
            <StyledCell css={{ borderRight: '1px solid $gray12' }}>
              <Box as="h4"> Enrolled Entity</Box>
              <Row>
                <Box as="h4" style={{ marginBottom: 8 }}>
                  {TERMINOLOGY.partner.singular}:
                </Box>
                <Box as="h4" style={{ fontWeight: 'normal' }}>
                  {insurancePolicies?.companyName} Inc.
                </Box>
              </Row>
              <Row>
                <Box as="h4" style={{ marginBottom: 8 }}>
                  Company Address:
                </Box>
                <Box as="h4" style={{ fontWeight: 'normal' }}>
                  22316 Westheimer Parkway, #708, Katy, TX. 77450
                </Box>
              </Row>
            </StyledCell>
            <StyledCell>
              <Box as="h4">WARRANTY BENEFITS PROVIDER: </Box>
              <Row>
                {/* <Box as="h4" css={InlineTextCss} style={{ marginBottom: 8 }}>
                  INSURER A :
                </Box> */}
                <Box as="h4" style={{ fontWeight: 'normal' }}>
                  {insurancePolicies?.companyName} Inc.
                </Box>
              </Row>
            </StyledCell>
          </StyledRow>
        </StyledTable>
        <Content />
        <StyledTable css={TableStyle} style={{ tableLayout: 'auto' }}>
          <StyledRow css={RowStyle} className="td">
            <StyledCell as="th" css={{ fontWeight: '$semibold', borderRight: '1px solid $gray12' }}>
              CLASS
            </StyledCell>
            <StyledCell as="th" css={{ fontWeight: '$semibold', borderRight: '1px solid $gray12' }}>
              TYPE OF WARRANTY
            </StyledCell>
            <StyledCell as="th" css={{ fontWeight: '$semibold', borderRight: '1px solid $gray12' }}>
              {TERMINOLOGY.warranty.singular.toUpperCase()} ID
            </StyledCell>
            <StyledCell as="th" css={{ fontWeight: '$semibold', borderRight: '1px solid $gray12' }}>
              ACTIVATION DATE
            </StyledCell>
            <StyledCell as="th" css={{ fontWeight: '$semibold', borderRight: '1px solid $gray12' }}>
              EXPIRATION DATE
            </StyledCell>
            <StyledCell as="th" css={{ fontWeight: '$semibold' }}>
              WARRANTY BENEFIT
            </StyledCell>
          </StyledRow>

          <StyledRow>
            <StyledCell css={{ borderRight: '1px solid $gray12' }}>A</StyledCell>
            <StyledCell css={{ borderRight: '1px solid $gray12' }}>
              <Box as="h4">Cyber {TERMINOLOGY.warranty.singular.toLowerCase()}</Box>

              <Box as="h4" style={{ fontWeight: 'normal' }}>
                {insurancePolicies?.planName}
              </Box>
            </StyledCell>
            <StyledCell css={{ borderRight: '1px solid $gray12', fontWeight: 'normal' }}>{insurancePolicies?.trackingId}</StyledCell>
            <StyledCell css={{ borderRight: '1px solid $gray12', fontWeight: 'normal' }}>{new Date(insurancePolicies?.startDate).toDateString()}</StyledCell>
            <StyledCell css={{ borderRight: '1px solid $gray12', fontWeight: 'normal' }}>{new Date(insurancePolicies?.endDate).toDateString()}</StyledCell>
            <StyledCell>
              <Box as="h4" style={{ fontWeight: 'normal' }}>
                {insurancePolicies?.maxCoverage}
              </Box>
            </StyledCell>
          </StyledRow>
        </StyledTable>
        <BottomContent email={userAddress} name={currentUserName} sig={signatureFiles} />
      </Root>
    </>
  )
}

const Content = () => {
  return (
    <>
      <Heading css={{ mt: '$3 !important' }}>
        <Box as="h1" className="mainHeading" css={{ fontSize: '$lg' }}>
          {constants.heading}
        </Box>
      </Heading>
      <ContentWrapper>
        <Box as="p" className="certificateTextLine1" css={{ fontWeight: '$normal' }}>
          {constants.certificateTextLine1}
        </Box>
        <Box as="p" className="certificateTextLine2" css={{ fontWeight: '$normal' }}>
          {constants.certificateTextLine2}
        </Box>
        <Box as="p" className="certificateSubText" css={{ fontWeight: '$normal' }}>
          {constants.certificateVerificationText}
        </Box>
        <Box as="p" className="certificateNote" css={{ fontWeight: '$normal' }}>
          {constants.certificateMaxBenefitText}
        </Box>
      </ContentWrapper>
    </>
  )
}
const TopContent = () => {
  return (
    <>
      <Box css={{ display: 'flex', justifyContent: 'center' }}>
        <Box as="img" css={logo} src="/images/dlt-alert-logo-black.png" alt="logo" />
      </Box>
      {/* heading */}
      <Heading>
        <Box as="h1" className="mainHeading">
          {constants.heading}
        </Box>
      </Heading>

      {/* Content after heading */}
      <ContentWrapper>
        {/* <Box as="p" className="mainContent" css={{ fontWeight: '$semibold' }}>
          {constants.mainContent}
        </Box> */}
        <Box as="p" className="important" css={{ fontWeight: '$semibold' }}>
          {constants.important}
        </Box>
        <Box as="p" className="subHeading" css={{ fontWeight: '$semibold', mt: '$2   !important' }}>
          {constants.subHeading}
        </Box>
      </ContentWrapper>
    </>
  )
}
const BottomContent = (props: { email: string | undefined; name: string | undefined; sig: string[] | undefined }) => {
  return (
    <>
      {/* AfterTable Content */}
      <ContentWrapper>
        <Box as="p" className="contentAfterTable" css={{ fontWeight: '$semibold' }}>
          {constants.description}
        </Box>
        {/* <Box as="p" className="contentAfterTable" css={{ fontWeight: '$normal', mt: '40px' }}>
          Proof of Warranty.
        </Box> */}
      </ContentWrapper>
      {/* user and insurance details */}
      <Box css={{ width: 'auto', mx: '$7' }}>
        {/* <Box css={{ width: '50%', float: 'left' }}>
          <Box as="h4"> CERTIFICATE HOLDER</Box>
          <Box as="p">{props.name}</Box>
          <Box as="p">{props.email}</Box>
        </Box> */}
        <Box css={{ width: '50%', float: 'left' }}>
          <Box as="h4">Confirmation of active, telemetry-validated </Box>
          <Box as="h4">warranty protection. </Box>
        </Box>
        <Box css={{ width: '50%', float: 'right' }}>
          <Box as="h4">AUTHORIZED REPRESENTATIVE</Box>
          {props.sig && <Box css={{ width: '40%' }} as="img" src={props.sig[0]} />}
        </Box>
        <div style={{ clear: 'both' }}></div>
      </Box>
      <Footer>
        <Box as="h4" className="heading">
          {' '}
          CANCELLATION{' '}
        </Box>
        <Box as="p" css={{ fontWeight: '$semibold', textAlign: 'center' }}>
          Warranty status is continuously evaluated based on required security controls and telemetry inputs.
        </Box>
        <Box as="h4" className="content">
          {' '}
          {constants.cancellation}{' '}
        </Box>
      </Footer>
    </>
  )
}
